module.exports = __webpack_public_path__ + "img/form-arrow.svg?ee687edadb06c3ba91d349691c9b129c";